module.exports = __webpack_public_path__ + "assets/Bell.2f676a13.svg";